import { render } from "./TagList.vue?vue&type=template&id=080bbd98&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"

import "./TagList.vue?vue&type=style&index=0&id=080bbd98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-080bbd98"

export default script